import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex q-ma-lg justify-center" }
const _hoisted_2 = { class: "text-italic" }


import { ref } from 'vue';

const __default__ = { name: 'DashboardView' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const greet = ref('Бобро пожаловац');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(greet.value), 1)
  ]))
}
}

})